import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './components/contactus.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppMaterialComponentsModule } from '../app-material-components/app-material-components.module';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
@NgModule({
  declarations: [ContactUsComponent],
  exports: [ContactUsComponent],
  imports: [
    CommonModule,
    AppMaterialComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective, NgxMaskPipe,
  ],providers: [provideNgxMask()]
})
export class ContactUsModule { }
